import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetSaleRequestShippingCountQueryResponse, GetSaleRequestShippingCountPathParams, GetSaleRequestShippingCount404, GetSaleRequestShippingCount500 } from "../types/GetSaleRequestShippingCount";

export const getSaleRequestShippingCountQueryKey = (requestId: GetSaleRequestShippingCountPathParams["requestId"]) =>     [{url:`/api/salerequests/${requestId}/shipping/count`,params:{requestId:requestId}}] as const;
      export function getSaleRequestShippingCountQueryOptions <TData = GetSaleRequestShippingCountQueryResponse, TError = GetSaleRequestShippingCount404 | GetSaleRequestShippingCount500>(requestId: GetSaleRequestShippingCountPathParams["requestId"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getSaleRequestShippingCountQueryKey(requestId, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/salerequests/${requestId}/shipping/count`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение подсчетов по незакрытым отгрузкам
 * @link /api/salerequests/:requestId/shipping/count
 */

export function useGetSaleRequestShippingCount <TData = GetSaleRequestShippingCountQueryResponse, TError = GetSaleRequestShippingCount404 | GetSaleRequestShippingCount500>(requestId: GetSaleRequestShippingCountPathParams["requestId"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSaleRequestShippingCountQueryKey(requestId, );

  const query = useQuery<TData, TError>({
    ...getSaleRequestShippingCountQueryOptions<TData, TError>(requestId, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
